module.exports = __webpack_public_path__ + "static/img/banner-doctor.925c6d4d.png";